import { RegionShared } from "@1games-ru/region-shared";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { inventoryMapSelector, setInventory } from "@/domains/inventory/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useGetInventory() {
  const dispatch = useAppDispatch();
  const inventoryMap = useAppSelector(inventoryMapSelector);
  const getInventory = useCallback(
    async (data: typeof RegionShared.Backend.Requests.GetInventoryRequest) => {
      const response = await RpcMpProvider.callServer<
        typeof RegionShared.Backend.Requests.GetInventoryRequest,
        typeof RegionShared.Backend.Responses.GetInventoryResponse
      >(RegionShared.Backend.Events.Inventory.GetInventory, {
        ...data,
        inventoryOwnerId: String(data.inventoryOwnerId),
      });

      if (response instanceof RpcMpProviderSuccessResponse) {
        dispatch(setInventory(response.data.inventory));
        return response.data.inventory;
      } else {
        toast.error(response.message);
        console.trace({ e: response.error, data });
        return null;
      }
    },
    [dispatch, inventoryMap],
  );
  return {
    getInventory,
  };
}
